import BusinessRule from "./BusinessRule.vue";
import Section from "./Section.vue";
import Default from "./DefaultContentControl.vue";

export default {
    Default,
    BusinessRule,
    Section
}